// (c) 2023 ABBYY Development, Inc.

import { ChangeEvent, Dispatch, FC, useEffect } from 'react';
import { Box, Input, Gaped, FormControlLabel } from 'components';
import { useTranslation } from 'react-i18next';

interface NumberRangeFilterProps {
    defaultMin: number;
    defaultMax: number;
    filter: any;
    setFilter: Dispatch<any>;
    enableFilter: () => void;
    disableFilter: () => void;
}

const formatInput = (input: string) => {
    const parsedValue = parseInt(input);

    return Number.isNaN(parsedValue) ? '' : parsedValue;
};

const NumberRangeFilter: FC<NumberRangeFilterProps> = ({
    defaultMin,
    defaultMax,
    filter,
    setFilter,
    enableFilter,
    disableFilter
}) => {
    const { t } = useTranslation();

    useEffect(() => {
        if (filter?.value?.from === '' || filter?.value?.to === '') {
            disableFilter();
        } else {
            enableFilter();
        }
    }, [disableFilter, enableFilter, filter]);

    const onMinChange = (event: ChangeEvent<HTMLInputElement>) => {
        setFilter({
            value: {
                ...filter?.value,
                from: formatInput(event.target.value)
            }
        });
    };

    const onMaxChange = (event: ChangeEvent<HTMLInputElement>) => {
        setFilter({
            value: {
                ...filter?.value,
                to: formatInput(event.target.value)
            }
        });
    };

    return (
        <Box mt={2} mb={3} ml={2} mr={2}>
            <Gaped>
                <FormControlLabel labelPlacement="top" label={t('general.Min')}>
                    <Input
                        type={'string'}
                        value={filter?.value?.from}
                        onChange={onMinChange}
                        placeholder={defaultMin.toString()}
                    />
                </FormControlLabel>
                <FormControlLabel labelPlacement="top" label={t('general.Max')}>
                    <Input
                        type={'string'}
                        value={filter?.value?.to}
                        onChange={onMaxChange}
                        placeholder={defaultMax.toString()}
                    />
                </FormControlLabel>
            </Gaped>
        </Box>
    );
};

export default NumberRangeFilter;
